<template>
  <div>
    <div class="preloader">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>

    <div id="main-bg" class="parallax"></div>

    <nav class="navbar navbar-light bg-light d-none">
      <a class="navbar-brand" href="/game/create" title="start">
        <img
          src="../../public/img/favicon.png"
          width="30"
          height="30"
          class="d-inline-block align-top"
          alt=""
        />
        MATH PK
      </a>
    </nav>

    <div class="section intro-section p-5 animated fadeIn delay-2s">
      <div class="midscreen">
        <h1 class="mb-3 mb-sm-2 mb-md-0">
          <img
            src="../../public/img/simba_logo.png"
            alt="Logo"
            class="logo animated fadeIn delay-1s"
          />
        </h1>

        <div class="text-center animated fadeIn mt-5 mt-md-0">
          <a
            href="/start"
            class="btn btn-lg btn-success text-uppercase px-5 pulse infinite"
          >
            Play Now!
          </a>
        </div>
        <span class="small text-center mt-5 d-block" v-if="1===2"
          ><a class="text-nolink" href="#privacy"><img src="../../public/img/002-mouse-cursor.png" /> </a>
        </span>
      </div>
    </div>
    <div v-if="1===2" class="section half-section why-we-section p-5" id="why-we">
      <div class="row animated fadeInUp delay-2s">
        <div class="col-12 col-md-6 col-lg-4 mb-5">
          <span class="big-icon d-block text-center text-primary mb-3 mb-sm-0"
            ><i class="fas fa-comment-dollar"></i
          ></span>
          <h3 class="text-dark text-weight-bold border-0 text-center">Free</h3>
          <p class="text-center px-1 px-sm-2 px-md-4 px-lg-3 px-xl-5">
            The game is completely free for all players! In addition, no
            registration necessary. Just create a game and get started!
          </p>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-5">
          <span class="big-icon d-block text-center text-primary mb-3 mb-sm-0"
            ><i class="fas fa-user-friends"></i
          ></span>
          <h3 class="text-dark text-weight-bold border-0 text-center">Teams</h3>
          <p class="text-center px-1 px-sm-2 px-md-4 px-lg-3 px-xl-5">
            Play with up to 12 players per game and develop your own Tactics to
            destroy the enemy fleets.
          </p>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-5">
          <span class="big-icon d-block text-center text-primary mb-3 mb-sm-0"
            ><i class="fas fa-sliders-h"></i
          ></span>
          <h3 class="text-dark text-weight-bold border-0 text-center">
            Independent & Individual
          </h3>
          <p class="text-center px-1 px-sm-2 px-md-4 px-lg-3 px-xl-5">
            You don't need an app or program to play. Easy to use in the Open
            your browser and start playing. In addition, as the game master, you
            have the Options, settings such as pitch size or maximum number of
            players.
          </p>
        </div>
      </div>
    </div>
    <footer class="section sm-section bg-dark px-5 py-3">
      <div class="row">
        <div class="col-12 col-md-6 text-center text-md-left my-md-0">
          <p class="text-light m-0 p-0">
            <i class="fas fa-code mr-2"></i>by Tony Yao & Jason Yao
          </p>
        </div>
        <div class="col-12 col-md-6 text-center text-md-right my-md-0">
          <!--          <a class="text-light mx-2" href="/imprint">Impressum</a>-->
          <a class="text-light mx-2" href="/privacy">Privacy</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "home",
};
</script>
<style scoped>
nav {
  opacity: 0.6;
}

.section {
  min-height: 100vh;
}

.section.half-section {
  min-height: 50vh;
}

.section.sm-section {
  min-height: 2vh;
}

.intro-section {
  height: 100%;
  width: 100%;
  padding: 3rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.midscreen{
  padding-bottom:150px;
}

.intro-section h2 {
  font-size: 2.5rem;
}

.intro-section h3 {
  border: none !important;
}

.intro-section .subtitle {
  width: 700px;
  margin: 0 auto;
}

.intro-section .logo {
  margin: 0 auto;
  display: block;
  margin-top: 10px;
}

.why-we-section {
  background-color: #fff;
}

.why-we-section .big-icon {
  font-size: 5rem;
  transition: 0.4s ease all;
}

.why-we-section .big-icon:hover {
  transform: scale(1.2);
}

#main-bg {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../../public/img/bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}

.text-nolink {
  color: #000000;
}

.text-nolink:link {
  text-decoration: none;
}

footer{
  width:100%;
  position:fixed;
  bottom:0;
}


</style>
